
import { Vue, Component } from 'vue-property-decorator';
import { getDetail, getBaseInfo } from '../api';
import { Swipe, SwipeItem, Lazyload } from 'vant';
import CustomImagePreview from '../components/ImagePreview.vue';

Vue.use(Swipe)
  .use(SwipeItem)
  .use(Lazyload);
@Component({
  components: {
    CustomImagePreview,
  },
})
export default class HomeDetail extends Vue {
  bannerImg: string = '';
  inStream: any = ['小学组', '初中组'];
  obj: any = {};
  img: any = [
    'https://image2.cqcb.com/d/file/topics/activity/2022-03-31/6dE0kkRd-1648728382992.jpg',
    'https://image2.cqcb.com/d/file/topics/activity/2022-03-31/fjaMTt1A-1648728382779.jpg',
  ];
  baseInfo: any = {};
  isPreviewShow = false;
  previewIndex = 0;

  async activated() {
    const ret = await getBaseInfo();
    this.baseInfo = ret.data;
    const res: any = await getDetail(this.$route.query.id);
    this.obj = res.data;
  }
  getImg(imageList: any, index: number) {
    this.previewIndex = index;
    this.isPreviewShow = true;
  }
}
